module.exports = __webpack_public_path__ + "img/监控未获取数据@2x.b258ebc3.png";